// core
import React from "react";

// components
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";

interface ILegalAndDisclaimerModal {
    isOpen: boolean;
    onClose: () => void;
}

const LegalAndDisclaimerModal: React.FC<ILegalAndDisclaimerModal> = (props) => {
    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader onClose={props.onClose} title="Legal &amp; Disclaimer" />
                )}
                calcHeightMode="auto"
                width="wide"
                isOpen={props.isOpen}
                onClose={props.onClose}>
                {() => (
                    <React.Fragment>
                        <h4>
                            When you&apos;re using LifeDirect there are some important
                            things to be aware of and information that you might find
                            useful.
                        </h4>
                        <p className="gap-l">
                            This website has been developed in good faith to help you
                            compare insurers and policies and choose a suitable option.
                            However please note that before choosing an insurer or policy
                            you must satisfy yourself as to its suitability for your
                            situation, needs, and objectives.
                        </p>
                        <h4>Choosing your insurer</h4>
                        <p>
                            In choosing an insurer or policy you are acting on your own
                            behalf, and if you have any doubts about your decision you
                            should seek professional insurance advice.
                        </p>
                        <p>
                            Accordingly, Life Direct cannot be held liable for any
                            decisions you make on the basis of information on this site.
                            Neither Life Direct, nor its associated companies, directors,
                            employees or agents guarantee the performance of any insurer
                            or policy. We do not warrant or endorse any insurer or policy,
                            nor do we promote, or make any representation to any person as
                            to quality or suitability for any purpose of any insurance
                            policy available on this website. No liability is accepted for
                            any loss or damage incurred by any person as a result of using
                            any insurer or insurance policy available on this website.
                        </p>
                        <h4>Choosing a level of insurance and policy</h4>
                        <p>
                            The tools provided to help you choose a level of insurance
                            (for example our online calculator) or compare policies (for
                            example our policy comparison tools) are provided in good
                            faith, however they are of a general nature and might not be
                            relevant to your individual circumstances. Accordingly no
                            liability is accepted for any loss or damage incurred by any
                            person as a result of using the tools or information on this
                            website.
                        </p>
                        <p>By using this website you agree to the above conditions.</p>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default LegalAndDisclaimerModal;
